// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root .G2boy{background-color:unset}:root .G2boy .l_0ll,:root .G2boy .M0VBc,:root .G2boy .hvomI{background-color:#1c1e1f}:root .G2boy .l_0ll{border-top-color:#93897926}:root .G2boy .anoBq,:root .G2boy .aXfrD,:root .G2boy .KK9wt{color:#ffffffde}:root .G2boy .hvomI{color:#ffffffd9;font-size:26.4px;font-size:1.65rem}:root .G2boy .KK9wt{font-size:19.2px;font-size:1.2rem;margin-bottom:1.5rem}:root .G2boy .anoBq,:root .G2boy .aXfrD{font-size:17.6px;font-size:1.1rem}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"confirmationModal": `G2boy`,
	"actions": `l_0ll`,
	"content": `M0VBc`,
	"title": `hvomI`,
	"extraContent": `anoBq`,
	"text": `aXfrD`,
	"textHeader": `KK9wt`
};
module.exports = ___CSS_LOADER_EXPORT___;
